var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",staticClass:"trace-region",attrs:{"removeOnClose":""},on:{"close":_vm.handleDestroy}},[(_vm.loaded)?_c('blocks-half-marquee',{attrs:{"block":_vm.block}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }